<template>
  <div v-if="!isPrint">
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 안전보건관리담당자 정보 -->
    <write-grid-container :title="$t('안전보건관리담당자 정보')" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{form.subInfo[value]}}</div>
          <div v-else-if="dataType === 'sign'" class="w-full flex-1 p-1">
            <img v-if="form.subInfo[value]" :src="form.subInfo[value]" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
          <div class="print-input" v-else>{{form.subInfo[value]}}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <div v-else-if="dataType === 'blank'"></div>
          <sign-field v-else-if="dataType === 'sign'" v-model="form.subInfo[value]" class="w-full flex-1 p-1" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <file-download-post class="mt-8" :title="$t('파일첨부')" v-model="form.fileList"/>
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import SignField from "@/components/SignField.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    SignField,
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      gridContainerOptions: {
        dataTypes: ["string", "sign", "string", "string", "string", "date", "string", ],
        labels: ["성명", "서명", "소속명", "직책", "자격", "선임일", "대표이사"],
        values: ["성명", "서명", "소속명", "직책", "자격", "선임일", "대표이사"],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = '';
      return acc;
    }, {})

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
